import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enProfile from './locales/en/profile.json';
import enSidebar from './locales/en/sidebar.json';
import enHome from './locales/en/home.json';
import enApplicants from './locales/en/applicants.json';
import enMyteam from './locales/en/myteam.json';
import enOnboarding from './locales/en/onboarding.json';
import enContracts from './locales/en/contracts.json';
import enSourcing from './locales/en/sourcing.json';
import enExternalApps from './locales/en/externalApps.json';
import enOrgIntelligence from './locales/en/orgIntelligence.json';
import enPricing from './locales/en/pricing.json';
import enCommunity from './locales/en/community.json';
import enNationalization from './locales/en/nationalization.json';
import enUi from './locales/en/ui.json';

// Arabic translations
import arCommon from './locales/ar/common.json';
import arAuth from './locales/ar/auth.json';
import arProfile from './locales/ar/profile.json';
import arSidebar from './locales/ar/sidebar.json';
import arHome from './locales/ar/home.json';
import arApplicants from './locales/ar/applicants.json';
import arMyteam from './locales/ar/myteam.json';
import arOnboarding from './locales/ar/onboarding.json';
import arContracts from './locales/ar/contracts.json';
import arSourcing from './locales/ar/sourcing.json';
import arExternalApps from './locales/ar/externalApps.json';
import arOrgIntelligence from './locales/ar/orgIntelligence.json';
import arPricing from './locales/ar/pricing.json';
import arCommunity from './locales/ar/community.json';
import arNationalization from './locales/ar/nationalization.json';
import arUi from './locales/ar/ui.json';

const resources = {
    en: {
        ui: enUi,
        common: enCommon,
        auth: enAuth,
        profile: enProfile,
        sidebar: enSidebar,
        home: enHome,
        applicants: enApplicants,
        myteam: enMyteam,
        onboarding: enOnboarding,
        contracts: enContracts,
        sourcing: enSourcing,
        externalApps: enExternalApps,
        orgIntelligence: enOrgIntelligence,
        pricing: enPricing,
        community: enCommunity,
        nationalization: enNationalization
    },
    ar: {
        ui: arUi,
        common: arCommon,
        auth: arAuth,
        profile: arProfile,
        sidebar: arSidebar,
        home: arHome,
        applicants: arApplicants,
        myteam: arMyteam,
        onboarding: arOnboarding,
        contracts: arContracts,
        sourcing: arSourcing,
        externalApps: arExternalApps,
        orgIntelligence: arOrgIntelligence,
        pricing: arPricing,
        community: arCommunity,
        nationalization: arNationalization
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        supportedLngs: ['en', 'ar'],
        ns: ['ui', 'common', 'auth', 'profile', 'sidebar', 'home', 'applicants', 'myteam', 'onboarding', 'contracts', 'sourcing', 'externalApps', 'orgIntelligence', 'pricing', 'community', 'nationalization'],
        defaultNS: 'common',
        interpolation: {
            escapeValue: false // React already handles XSS
        },
        detection: {
            order: ['localStorage', 'navigator'],
            // Only explicit choices (or a loaded account preference) are saved by
            // LanguageProvider. Caching browser detection hides whether a person
            // has actually chosen a language before account settings arrive.
            caches: [],
            lookupLocalStorage: 'i18nextLng'
        },
        react: {
            useSuspense: false // Disable suspense to avoid loading issues
        }
    });

// Helper to check if current language is RTL
export const isRTL = () => {
    const rtlLanguages = ['ar', 'he', 'fa', 'ur'];
    return rtlLanguages.includes(i18n.language?.split('-')[0]);
};

export { normalizeLanguage } from './utils/languagePreference';

// Helper to get direction
export const getDirection = () => isRTL() ? 'rtl' : 'ltr';

export default i18n;
